import { Col, Radio } from "antd";
import React from "react";
const IncomeStaffRadio = (props) => {
  // -------------------------- VAR --------------------------
  const { tab, setTab } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  const handleChange = (e) => {
    setTab(e.target.value);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Col span={24}>
      <Radio.Group
        defaultValue="waiting"
        buttonStyle="solid"
        style={{ width: "100%" }}
        onChange={handleChange}
        size="large"
      >
        <Radio.Button value="waiting" className="radio-group-tabs">
          Waiting List
        </Radio.Button>
        <Radio.Button value="done" className="radio-group-tabs">
          Completed List
        </Radio.Button>
      </Radio.Group>
    </Col>
  );
};
export default IncomeStaffRadio;